module.exports = __webpack_public_path__ + "static/media/menu mobile.6b7c5f41.png";